import { CommandResult, LinkReference, LinkReferenceType, ReferenceLink, ReferenceLinkCollection } from '../amorg-common';
import { apiPath } from "./adminClientApi";
import { commandAuthWrapper, queryAuthWrapper } from './serverApiHelpers';

export const getReferenceLinks = async (id: string, type: LinkReferenceType): Promise<ReferenceLinkCollection> =>
{
    const data = await queryAuthWrapper(`${apiPath}/referenceLinks/${type}/${id}`);
    return data;
};


export const setReferenceLinks = async (reference: LinkReference, links: ReferenceLink[]): Promise<CommandResult> =>
{
    return commandAuthWrapper(`${apiPath}/referenceLinks`, 'POST',
        { reference, links }
    );
}